import { yupResolver } from '@hookform/resolvers/yup'
import { useTranslation } from 'next-i18next'
import Link from 'next/link'
import { useState } from 'react'
import { useForm } from 'react-hook-form'
import styled from 'styled-components'
import { Button } from '@fe/common/components/Button'
import { Input } from '@fe/common/components/inputs/Input'
import {
  BottomLink,
  BottomOptions,
  BottomErrorText,
  LoginForm,
} from '@fe/common/components/loggedOutStyles'
import { useCancelToken } from '@fe/common/hooks/useCancelToken'
import { formatResponseError } from '@fe/common/utils/axiosUtils'
import yup from '@fe/common/yup/yupConfig'
import { PasswordApi } from 'src/api/PasswordApi'
import { LOGIN } from 'src/constants/routes'
// import { useRecaptcha } from '@fe/common/hooks/useRecaptcha'

const InfoText = styled.p`
  margin-bottom: 4rem;
`

const forgotPasswordSchema = yup.object().shape({
  email: yup.string().email().trim().required(),
})

interface ForgotPasswordData {
  email: string
}

interface EmailStep {
  incrementStep: () => void
}

export const EmailStep: React.FC<EmailStep> = ({ incrementStep }) => {
  const { t } = useTranslation('no-auth')
  const [error, setError] = useState('')

  const { register, handleSubmit, errors, formState } =
    useForm<ForgotPasswordData>({
      mode: 'onBlur',
      resolver: yupResolver(forgotPasswordSchema),
    })

  // const { ReCaptcha, checkCaptcha } = useRecaptcha('forgotPassword')
  const cancelToken = useCancelToken()

  const onSubmit = async ({ email }: ForgotPasswordData) => {
    try {
      // await checkCaptcha()

      await PasswordApi.requestResetLink(email, {
        cancelToken,
      })

      incrementStep()
    } catch (error) {
      console.error(error)

      const formattedError = formatResponseError(error, t)

      setError(formattedError)
    }
  }

  return (
    <>
      <LoginForm onSubmit={handleSubmit(onSubmit)}>
        <InfoText>{t('reset-password-info')}</InfoText>

        <Input
          name="email"
          label={t('common:email')}
          type="email"
          isFullWidth
          isFocused
          errors={errors}
          formState={formState}
          ref={register}
        />

        <Button isFullWidth isSubmit isLoading={formState.isSubmitting}>
          {t('reset-password')}
        </Button>

        {error && <BottomErrorText>{error}</BottomErrorText>}
      </LoginForm>

      <BottomOptions>
        <Link href={LOGIN} passHref>
          <BottomLink>{t('return-to-login')}</BottomLink>
        </Link>
      </BottomOptions>

      {/* <ReCaptcha /> */}
    </>
  )
}
